import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { AccountSettingsPageInitialData } from "./accountSettingsPageInitialData";

export const ACCOUNT_SETTINGS_PAGE_ID = "my-account/accountSettings";

export const accountSettingsPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.accountSettings(),
    queryFn: () =>
      fetchOccPageData<PageInitialDataResult<AccountSettingsPageInitialData>>(`/page-data/${ACCOUNT_SETTINGS_PAGE_ID}`),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
